import { useTranslation } from 'react-i18next';
import ContactListPresentational from './ContactListPresentational';
import LoadingIndicator from '@/modules/core/client/components/LoadingIndicator';
import NoContent from '@/modules/core/client/components/NoContent';
import React, { useState } from 'react';
import type { ContactList as ContactListData, ContactRecord } from '../types';
import type { UserProfile } from '@/modules/users/client/types';

export default function ContactList({
  appUser,
  contacts,
  onContactRemoved,
}: {
  appUser: UserProfile;
  contacts?: ContactListData;
  onContactRemoved: (contact: ContactRecord) => void;
}) {
  const { t } = useTranslation('contacts') as {
    t: (key: string, options?: Record<string, unknown>) => string;
  };
  const [filter, setFilter] = useState('');

  if (!contacts || !contacts.$resolved) {
    return <LoadingIndicator />;
  }

  if (contacts.length === 0) {
    return <NoContent icon="users" message={t('No contacts yet.')} />;
  }

  return (
    <ContactListPresentational
      contacts={contacts}
      filter={filter}
      onContactRemoved={onContactRemoved}
      onFilterChange={setFilter}
      selfId={appUser._id}
    />
  );
}
